<section>
	<div class="row">
		<div class="col-sm-12">
			<app-information strModule="users"
				[isPanel1Visible]= "true"
				[isPanel2Visible]= "true"
				[isPanel3Visible]= "true"
				[showLegend]="false">
			</app-information>
		</div>
		<div class="col-sm-12">
			<fm-listing
				strModule="users"
				[bShowCustomList]="false"
				[objHeaderData]="objTableHeaderData"
				[bAllowCheckboxSelection]="true"
			>
				<ng-template
					#customListItemAction
					let-item="item"
				>
					<admin-users-send-welcome-email-button
						*ngIf="(item | data_get: 'status') == 'active'"
						[user]="item"
					></admin-users-send-welcome-email-button>

					<user-change-password-button
						*ngIf=" (item | data_get: 'level') != 'queuing' && (item | data_get: 'status') == 'active'"
						[user]="item"
					></user-change-password-button>
				</ng-template>
			</fm-listing>
		</div>
	</div>
</section>